import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import {
  HeaderSite,
  HeaderContainer,
  GradientLine
} from './styles';

import LogoEinstein from '../../../assets/logo.png';

export default function Header(): ReactElement {
  return (
    <HeaderSite>
      <HeaderContainer>
      <Link to="/">
        <img src={LogoEinstein} width={'200px'} alt="" />
      </Link>
      </HeaderContainer>
      <GradientLine />
    </HeaderSite>
  );
}
